<template>
    <div class="iframe-container">
        <iframe
            src="https://app.pickcode.io/lesson/coco-coders-free-python-lesson-lesson-cmls6vyn8019yhk96n9flqj4k-2026-05-19-10-31-33?embed=true"></iframe>
    </div>
</template>

<script setup>
import { onMounted } from 'vue';

onMounted(() => {
    document.title = 'Python';
});
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.iframe-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;

    iframe {
        width: 100%;
        height: 100%;
        border: none;
        display: block;
        /* Prevents tiny alignment gaps at the bottom */
    }
}
</style>